import {enableProdMode, importProvidersFrom, inject, provideAppInitializer} from '@angular/core';

import {initializeApp} from './app/app.module';
import {environment} from './environments/environment';
import {AppComponent} from './app/app.component';
import {CoreModule} from './app/core/core.module';
import {NgxHmCarouselModule} from 'ngx-hm-carousel';
import {UasPortalModule} from './app/portal/uas-portal.module';
import {OauthModule} from './app/oauth/oauth.module';
import {OAuthModule} from 'angular-oauth2-oidc';
import {APP_ROUTES} from './app/app.routing';
import {PreloadAllModules, provideRouter, withPreloading} from '@angular/router';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {provideAnimations} from '@angular/platform-browser/animations';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {SessionConfigService} from './app/core/services/session-config.service';
import {RequestInterceptor} from './app/core/services/http-interceptor';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(BrowserModule, NgbModule, OAuthModule.forRoot(), OauthModule, UasPortalModule, NgxHmCarouselModule, CoreModule),
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
    provideAppInitializer(() => {
      const initializerFn = (initializeApp)(inject(SessionConfigService));
      return initializerFn();
    }),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(APP_ROUTES, withPreloading(PreloadAllModules))
  ]
})
  .catch(err => console.log(err));
